// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__17dgx","title":"ClientReferral_title__1CY4U","itemText":"ClientReferral_itemText__ybV0W"};